import { render } from "./DepartmentLevelInventoryList.vue?vue&type=template&id=1667b2d6&scoped=true&ts=true"
import script from "./DepartmentLevelInventoryList.vue?vue&type=script&lang=ts"
export * from "./DepartmentLevelInventoryList.vue?vue&type=script&lang=ts"

import "./DepartmentLevelInventoryList.vue?vue&type=style&index=0&id=1667b2d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1667b2d6"]])

export default __exports__